import {LayoutState} from "../../core/models/layout";

export const initialState: LayoutState = {
  loading: false,
  messageToast: '',
  darkMode: 'light',
  title: '',
  toggleSidenav: true
};
